import {SelectOption} from "@/types/core";
import {ConfigurationProfile} from "@/components/device/configuration/types";

export const trackingModeList:SelectOption[] = [{
  label: 'Standby',
  value: 'standby',
}, {
  label: 'Motion tracking',
  value: 'motion_tracking',
}, {
  label: 'Permanent tracking',
  value: 'permanent_tracking',
}, {
  label: 'Motion start/end tracking',
  value: 'motion_start_end_tracking',
}, {
  label: 'Activity tracking',
  value: 'activity_tracking',
}];

export const geolocationTechnologyMethodList: SelectOption[] = [{
  label: 'WIFI',
  value: 'wifi',
}, {
  label: 'GPS',
  value: 'gps',
}, {
  label: 'LPGPS (AGPS/GPS)',
  value: 'lpgps_agps_gps',
}, {
  label: 'WIFI/GPS only',
  value: 'wifi_gps_only',
}, {
  label: 'WIFI-LPGPS only',
  value: 'wifi_lpgps_only',
}, {
  label: 'BLE scan only',
  value: 'ble_scan_only',
}, {
  label: 'BLE-GPS only ',
  value: 'ble_gps_only ',
}];

export const geolocationTechnologySensorList: SelectOption[] = [{
  label: 'WIFI only',
  value: 'wifi_only',
}, {
  label: 'GPS only',
  value: 'gps_only',
}, {
  label: 'LPGPS (AGPS/GPS)',
  value: 'lpgps_agps_gps',
}, {
  label: 'WIFI/GPS only',
  value: 'wifi_gps_only',
}, {
  label: 'WIFI-LPGPS only',
  value: 'wifi_lpgps_only',
}, {
  label: 'WIFI-LPGPS first',
  value: 'wifi_lpgps_first',
}, {
  label: 'BLE scan only',
  value: 'ble_scan_only',
}, {
  label: 'BLE-GPS only ',
  value: 'ble_gps_only ',
}];

const collectionScanTypeList: SelectOption[] = [{
  label: 'No collection scan',
  value: 'no_collection_scan',
}, {
  label: 'BLE collection scan',
  value: 'ble_collection_scan',
}, {
  label: 'WIFI collection scan',
  value: 'wifi_collection_scan',
}];

const collectionBleFilterTypeList: SelectOption[] = [{
  label: 'No filter',
  value: 'no_filter',
}, {
  label: 'Eddystone UID only',
  value: 'eddystone_uid_only',
}, {
  label: 'Eddystone URL only',
  value: 'eddystone_url_only',
}, {
  label: 'All Eddystone',
  value: 'all_eddystone',
}, {
  label: 'iBeacon UID only',
  value: 'ibeacon_uid_only',
}, {
  label: 'altBeacon only',
  value: 'altbeacon_only',
}];

const gnssConstellationList: SelectOption[] = [{
  label: 'GPS only',
  value: 'gps_only',
}, {
  label: 'GLONASS only',
  value: 'glonass_only',
}, {
  label: 'GPS and GLONASS',
  value: 'gps_and_glonass',
}, {
  label: 'GPS and Galileo',
  value: 'gps_and_galileo',
}, {
  label: 'GPS, GLONASS and Galileo',
  value: 'gps_and_glonass_and_galileo',
}, {
  label: 'Beidou only',
  value: 'beidou_only',
}, {
  label: 'GPS and Beidou',
  value: 'gps_and_beidou',
}];

const positionBLEFilterTypeList: SelectOption[] = [{
  label: 'No filter',
  value: 'no_filter',
}, {
  label: 'Eddystone UID only',
  value: 'eddystone_uid_only',
}, {
  label: 'Eddystone URL only',
  value: 'eddystone_url_only',
}, {
  label: 'All Eddystone',
  value: 'all_eddystone',
}, {
  label: 'iBeacon UID only',
  value: 'ibeacon_uid_only',
}, {
  label: 'altBeacon only',
  value: 'altbeacon_only',
}];

const positionBLEReportTypeList: SelectOption[] = [{
  label: 'MAC address',
  value: 'mac_address',
}, {
  label: 'Short ID',
  value: 'short_id',
}, {
  label: 'Long ID',
  value: 'long_id',
}];

export const deviceConfigurationProfile:ConfigurationProfile = {
  '0xf9': {
    id: 0xf9,
    stringId: 'mode',
    label: 'tracking mode',
    type: 'option',
    options: trackingModeList,
    position: 0,
    newUiSection: true,
    sectionId: '0xf9',
  },
  '0x00': {
    id: 0x00,
    stringId: 'ul_period',
    label: 'position messages period',
    type: 'number',
    unit: 'seconds',
    min: 60,
    max: 86400,
    position: 1,
    sectionId: '0xf9',
  },
  '0x01': {
    id: 0x01,
    stringId: 'lora_period',
    label: 'heartbeat messages period',
    type: 'number',
    unit: 'seconds',
    min: 300,
    max: 86400,
    position: 2,
    sectionId: '0xf9',
  },
  '0x05': {
    id: 0x05,
    stringId: 'geoloc_sensor',
    label: 'geolocation technology (operating mode)',
    type: 'option',
    options: geolocationTechnologySensorList,
    position: 3,
    sectionId: '0xf9',
  },
  '0x08': {
    id: 0x08,
    stringId: 'motion_nb_pos',
    label: 'number of positions to report during motion events',
    type: 'number',
    min: 1,
    max: 60,
    position: 4,
    sectionId: '0xf9',
  },
  '0x17': {
    id: 0x17,
    stringId: 'motion_duration',
    label: 'period of time required to detect the end of a motion',
    type: 'number',
    unit: 'seconds',
    min: 60,
    max: 3600,
    position: 5,
    sectionId: '0xf9',
  },
  '0x03': {
    id: 0x03,
    stringId: 'periodic_pos_period',
    label: 'periodic position report period',
    type: 'number',
    unit: 'seconds',
    min: 900,
    max: 604800,
    position: 6,
    newUiSection: true,
    sectionId: '0x03',
  },
  '0x06': {
    id: 0x06,
    stringId: 'geoloc_method',
    label: 'geolocation technology (periodic and on-demand position)',
    type: 'option',
    options: geolocationTechnologyMethodList,
    position: 7,
    sectionId: '0x03',
  },
  '0x16': {
    id: 0x16,
    stringId: 'periodic_activity_period',
    label: 'period of the periodic activity report (the value must be a multiple of 6)',
    type: 'number',
    unit: 'seconds',
    canBeZero: true,
    min: 1800,
    max: 86400,
    position: 8,
    sectionId: '0x03',
  },
  '0x21': {
    id: 0x21,
    stringId: 'collection_scan_type',
    label: 'collection scan type',
    type: 'option',
    options: collectionScanTypeList,
    position: 9,
    newUiSection: true,
    sectionId: '0x21',
  },
  '0x22': {
    id: 0x22,
    stringId: 'collection_nb_entry',
    label: 'maximum number of elements to report in collection payloads after a scan',
    type: 'number',
    min: 1,
    max: 20,
    position: 10,
    sectionId: '0x21',
  },
  '0x23': {
    id: 0x23,
    stringId: 'collection_ble_filter_type',
    label: 'beacon type to scan and report when collection scan type is BLE',
    type: 'option',
    options: collectionBleFilterTypeList,
    position: 11,
    sectionId: '0x21',
  },
  '0x24': {
    id: 0x24,
    stringId: 'collection_ble_filter_main_1',
    label: 'first part of the main BLE filter',
    type: 'string',
    maxStringLength: 10,
    position: 12,
    defaultValue: '0x00000000',
    sectionId: '0x21',
  },
  '0x25': {
    id: 0x25,
    stringId: 'collection_ble_filter_main_2',
    label: 'second part of the main BLE filter',
    type: 'string',
    maxStringLength: 10,
    position: 13,
    defaultValue: '0x00000000',
    sectionId: '0x21',
  },
  '0x26': {
    id: 0x26,
    stringId: 'collection_ble_filter_sec_value',
    label: 'BLE secondary value',
    type: 'string',
    maxStringLength: 10,
    position: 14,
    defaultValue: '0x00000000',
    sectionId: '0x21',
  },
  '0x27': {
    id: 0x27,
    stringId: 'collection_ble_filter_sec_mask',
    label: 'BLE secondary mask',
    type: 'string',
    maxStringLength: 10,
    position: 15,
    defaultValue: '0x00000000',
    sectionId: '0x21',
  },
  '0x2a': {
    id: 0x2a,
    stringId: 'gnss_constellation',
    label: 'configure the GNSS constellations used by the GPS chip to compute a position',
    type: 'option',
    options: gnssConstellationList,
    position: 16,
    newUiSection: true,
    sectionId: '0x2a',
  },
  '0x09': {
    id: 0x09,
    stringId: 'gps_timeout',
    label: 'timeout for GPS scans before sending a GPS timeout message',
    type: 'number',
    unit: 'seconds',
    min: 30,
    max: 300,
    position: 17,
    sectionId: '0x2a',
  },
  '0x0b': {
    id: 0x0b,
    stringId: 'gps_ehpe',
    label: 'acceptable GPS horizontal error for GPS geolocation',
    type: 'number',
    unit: 'meters',
    min: 0,
    max: 100,
    position: 18,
    sectionId: '0x2a',
  },
  '0x0c': {
    id: 0x0c,
    stringId: 'gps_convergence',
    label: 'time let to the GPS module to refine the calculated position',
    type: 'number',
    unit: 'seconds',
    min: 0,
    max: 300,
    position: 19,
    sectionId: '0x2a',
  },
  '0x11': {
    id: 0x11,
    stringId: 'gps_standby_timeout',
    label: 'duration of the GPS standby mode before going OFF',
    type: 'number',
    unit: 'seconds',
    min: 0,
    max: 28800,
    position: 20,
    sectionId: '0x2a',
  },
  '0x0a': {
    id: 0x0a,
    stringId: 'agps_timeout',
    label: 'timeout for LPGPS scans before sending the timeout message',
    type: 'number',
    unit: 'seconds',
    min: 30,
    max: 250,
    position: 21,
    sectionId: '0x2a',
  },
  '0x0f': {
    id: 0x0f,
    stringId: 'ble_beacon_cnt',
    label: 'this parameter provides the maximum number of BLE beacons to provide in payload',
    type: 'number',
    min: 1,
    max: 4,
    position: 22,
    newUiSection: true,
    sectionId: '0x0f',
  },
  '0x10': {
    id: 0x10,
    stringId: 'ble_beacon_timeout',
    label: 'BLE scan duration',
    type: 'number',
    unit: 'seconds',
    min: 1,
    max: 5,
    position: 23,
    sectionId: '0x0f',
  },
  '0x1a': {
    id: 0x1a,
    stringId: 'ble_rssi_filter',
    label: 'RSSI value to filter BLE beacons with BLE-GPS geolocation mode',
    type: 'number',
    unit: 'dBm',
    min: -100,
    max: -40,
    position: 24,
    sectionId: '0x0f',
  },
  '0x4d': {
    id: 0x4d,
    stringId: 'position_ble_filter_type',
    label: 'beacon type to scan and report when position Scan Type is BLE',
    type: 'option',
    options: positionBLEFilterTypeList,
    position: 25,
    sectionId: '0x0f',
  },
  '0x4e': {
    id: 0x4e,
    stringId: 'position_ble_filter_main_1',
    label: 'first part of the main BLE position filter',
    type: 'string',
    maxStringLength: 10,
    position: 26,
    defaultValue: '0x00000000',
    sectionId: '0x0f',
  },
  '0x4f': {
    id: 0x4f,
    stringId: 'position_ble_filter_main_2',
    label: 'second part of the main BLE position filter',
    type: 'string',
    maxStringLength: 10,
    position: 27,
    defaultValue: '0x00000000',
    sectionId: '0x0f',
  },
  '0x50': {
    id: 0x50,
    stringId: 'position_ble_filter_sec_value',
    label: 'position BLE secondary value',
    type: 'string',
    maxStringLength: 10,
    position: 28,
    defaultValue: '0x00000000',
    sectionId: '0x0f',
  },
  '0x51': {
    id: 0x51,
    stringId: 'position_ble_filter_sec_mask',
    label: 'position BLE secondary mask',
    type: 'string',
    maxStringLength: 10,
    position: 29,
    defaultValue: '0x00000000',
    sectionId: '0x0f',
  },
  '0x52': {
    id: 0x52,
    stringId: 'position_ble_report_type',
    label: 'configure the BLE data to report in payloads',
    type: 'option',
    options: positionBLEReportTypeList,
    position: 30,
    sectionId: '0x0f',
  },
  '0x14': {
    id: 0x14,
    stringId: 'motion_sensitivity',
    label: 'accelerometer configuration',
    type: 'number',
    unit: '%',
    min: 0,
    max: 100,
    position: 31,
    newUiSection: true,
    sectionId: '0x14',
  },
  '0x15': {
    id: 0x15,
    stringId: 'shock_detection',
    label: 'this parameter provides the configuration of the sensitivity of the shock detection',
    type: 'number',
    unit: '%',
    min: 0,
    max: 100,
    position: 32,
    sectionId: '0x14',
  },
  '0x53': {
    id: 0x53,
    stringId: 'buzzer_volume',
    label: 'configuration of the buzzer volume',
    type: 'number',
    unit: '%',
    min: 0,
    max: 100,
    position: 33,
    newUiSection: true,
    sectionId: '0x53',
  },
};
